import { BlindBrick } from './BlindBrick';
export default BlindBrick;
